const project_title = "后台管理模板";
const isFixHeader = false;
const isShowSidebarLogo = false;
const showSettings = true;
const tagsView = true;

export {
  project_title,
  isShowSidebarLogo,
  isFixHeader,
  showSettings,
  tagsView,
};
